import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export const hostfullyAssistDetailsSchema = () => ({
  agreeToPrivacy: Yup.boolean().oneOf([true]).required(),
  agreeToTerms: Yup.boolean().oneOf([true]).required(),
  selectedProperties: Yup.array().of(Yup.string().required()).min(1).required(),
});

export type HostfullyAssistDetailsFormSchemaType = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof hostfullyAssistDetailsSchema>>
>;
